import React,{useEffect, useState} from "react";
import { Constants } from "../Constants";

const SubmissionSuccess = () => {
	const message = Constants.messageIDToMessageMap["PostingSubmitSuccess"];

	useEffect(() => {
		// Get the page we're redirecting to from the search parameters returned by the post request
		const urlParams = new URLSearchParams(window.location.search);
		const redirectPageName = urlParams.get('redirectPage');
		const redirectPageUrl = Constants.pageNameToUrlMap[redirectPageName];

		setTimeout(function () {
			window.parent.location.replace(redirectPageUrl);
		}, 1000);
	}, true)

	return (
		<div>
			<h1 className="mt-5" style={{ textAlign: "center" }}>
				{message}
			</h1>
		</div>
	);
}

export { SubmissionSuccess };